import { fulfilled, pending, rejected, skeleton } from 'commons/constants';
import { reshapeData } from './report-utility';
import {
  CAMPAIGN_METRICS,
  SET_FRAC_SNAPSHOT,
  LIFT_STUDY,
  VISITS_DATA,
  FRACTIONAL_DATA,
  FREQUENCY_DATA,
  COHORT_ANALYSIS,
  DEMOGRAPHIC_DATA,
  DEVICE_METRICS_DATA,
  DRIVEN_VISITS_DATA,
  TOP_SEGMENTS_DATA,
  TOP_OOH_SEGMENTS_DATA,
  OOH_HOME_WORK_LOCATIONS_DATA,
  ATTRIBUTED_HOME_WORK_LOCATIONS_DATA,
  TOP_PLACES,
  LEADTIME_CONVERSION,
  DWELL_TIME,
  VISIT_SHARE_ANALYSIS,
  TOP_BILLBOARDS,
  DISTANCE_DATA,
  CAMPAIGN_FILTERS,
  AUDIENCE_FILTERS,
  OOH_AUDIENCE_FILTERS,
  PLACES_FILTERS,
  CLEAR_REPORT,
  PROFILE_COHORT_ANALYSIS,
  SEGMENT_COHORT_ANALYSIS,
  OOH_DEMOGRAPHIC_DATA,
  DSP_REPORTED_CAMPAIGN_DELIVERY_DATA,
  DSP_REPORTED_IMPRESSIONS_DATA,
  OBSERVED_REACH_FREQUENCY_DATA,
  ATTRIBUTED_AGE_GENDER_DATA,
  BILLBOARD_REACH_FREQUENCY_DATA,
  GET_HEAT_MAP_DATA_REQUEST,
  GET_HEAT_MAP_DATA_SUCCESS,
  GET_HEAT_MAP_DATA_FAILURE,
  GET_HEATMAP_FOR_IMPRESSIONS_REQUEST,
  GET_HEATMAP_FOR_IMPRESSIONS_SUCCESS,
  GET_HEATMAP_FOR_IMPRESSIONS_FAILURE,
  GET_HEATMAP_FOR_EXPOSURES_REQUEST,
  GET_HEATMAP_FOR_EXPOSURES_SUCCESS,
  GET_HEATMAP_FOR_EXPOSURES_FAILURE,
} from './reportConstants';

let initialState = {
  attributedHomeWorkLocations: {},
  heatMapData: { ...skeleton },
  dspHeatmapData: { ...skeleton },
  aggregationData: {},
  dspExposuresData: { ...skeleton },
  heatMap: {
    adGroupId: [],
    biilboard: [],
    state: [],
    creative: [],
  },
};

export default function (state, action) {
  state = state || initialState;
  switch (action.type) {
    case CAMPAIGN_METRICS:
      return { ...state, metrics: action.data };

    case SET_FRAC_SNAPSHOT:
      return { ...state, [action.data.frac]: action.data.data };

    case LIFT_STUDY:
      return { ...state, visitLift: action.data };

    case VISITS_DATA:
      return { ...state, visitsData: action.data };

    case FRACTIONAL_DATA:
      return { ...state, [action.data.fracType]: action.data.data };

    case FREQUENCY_DATA:
      return { ...state, frequency: action.data };

    case COHORT_ANALYSIS:
      return { ...state, cohortAnalysis: action.data };

    case DEMOGRAPHIC_DATA:
      return { ...state, demographic: action.data };

    case OOH_DEMOGRAPHIC_DATA:
      return { ...state, ooh_demographic: action.data };

    case DEVICE_METRICS_DATA:
      return { ...state, deviceMetrics: action.data };

    case DRIVEN_VISITS_DATA:
      return { ...state, drivenVisits: action.data };

    case TOP_SEGMENTS_DATA:
      return { ...state, topSegments: action.data };

    case TOP_OOH_SEGMENTS_DATA:
      return { ...state, oohTopSegments: action.data };

    case OOH_HOME_WORK_LOCATIONS_DATA:
      return { ...state, oohHomeWorkLocations: action.data };

    case ATTRIBUTED_HOME_WORK_LOCATIONS_DATA:
      return { ...state, attributedHomeWorkLocations: action.data };

    // Add Experian data code changes
    case ATTRIBUTED_AGE_GENDER_DATA:
      const age = action.data?.age
        ? Object.entries(action.data?.age).reduce(reshapeData, {})
        : [];
      const gender = action.data?.gender
        ? Object.entries(action.data?.gender).reduce(reshapeData, {})
        : [];
      return { ...state, attributedAgeGender: { age, gender } };

    case TOP_PLACES:
      return { ...state, topPlaces: action.data };

    case LEADTIME_CONVERSION:
      return { ...state, leadtime: action.data };

    case DWELL_TIME:
      return { ...state, dwellTime: action.data };

    case VISIT_SHARE_ANALYSIS:
      return { ...state, visitShare: action.data };

    case TOP_BILLBOARDS:
      return { ...state, billboards: action.data, billboardsFlag: action.flag };

    case DISTANCE_DATA:
      return { ...state, distance: action.data };

    case CAMPAIGN_FILTERS:
      return { ...state, campaignFilters: action.data };

    case AUDIENCE_FILTERS:
      return { ...state, audienceFilters: action.data };
    case OOH_AUDIENCE_FILTERS:
      return { ...state, oohAudienceFilters: action.data };

    case PLACES_FILTERS:
      return { ...state, placesFilters: action.data };

    case PROFILE_COHORT_ANALYSIS:
      return { ...state, profileCohortAnalysis: action.data };

    case SEGMENT_COHORT_ANALYSIS:
      return { ...state, segmentCohortAnalysis: action.data };

    case DSP_REPORTED_CAMPAIGN_DELIVERY_DATA:
      return { ...state, dspReportedCampaignDeliveryData: action.data };

    case DSP_REPORTED_IMPRESSIONS_DATA:
      return {
        ...state,
        impressionsData: action.data,
        impressionsDataFlag: action.flag,
      };

    case OBSERVED_REACH_FREQUENCY_DATA:
      return { ...state, observedReachFrequencyData: action.data };
    case BILLBOARD_REACH_FREQUENCY_DATA:
      return { ...state, billboardReachFrequencyData: action.data };
    case CLEAR_REPORT:
      return {};
    case GET_HEATMAP_FOR_IMPRESSIONS_REQUEST:
      return {
        ...state,
        dspHeatmapData: {
          ...skeleton,
          loader: pending,
        },
      };
    case GET_HEATMAP_FOR_IMPRESSIONS_SUCCESS:
      return {
        ...state,
        dspHeatmapData: {
          ...skeleton,
          loader: fulfilled,
          data: action.data?.id,
        },
      };
    case GET_HEATMAP_FOR_IMPRESSIONS_FAILURE:
      return {
        ...state,
        dspHeatmapData: {
          ...skeleton,
          loader: rejected,
          error: action.error,
        },
      };
    case GET_HEAT_MAP_DATA_REQUEST:
      return {
        ...state,
        heatMapData: {
          ...skeleton,
          loader: pending,
          state: action.payload?.data?.byGeo ?? {},
        },
      };
    case GET_HEAT_MAP_DATA_SUCCESS:
      const { id } = action.payload;
      if (id?.campaignScreenDetailsMap) {
        const {
          byScreenId = {},
          byGeo = {},
          byAdGroupId = {},
          byCreative = {},
        } = state.dspHeatmapData.data;
        const screenImpressions = Object.entries(byScreenId).reduce(
          (acc, [screenId, screenData]) => {
            return acc + screenData.impressions;
          },
          0
        );
        const stateImpressions = Object.entries(byGeo).reduce(
          (acc, [screenId, screenData]) => {
            return acc + screenData.impressions;
          },
          0
        );

        const newByScreenId = Object.entries(byScreenId).reduce(
          (acc, [screenId, screenData]) => {
            acc.push({
              ...screenData,
              screenId,
              latlng: id?.campaignScreenDetailsMap[screenId],
            });
            return acc;
          },
          []
        );
        const newByGeo = Object.entries(byGeo).reduce(
          (acc, [stateId, stateData]) => {
            acc.push({
              ...stateData,
              name: stateId,
              percent: +(
                ((stateData.impressions ?? 0) / stateImpressions) *
                100
              ).toFixed(2),
            });
            return acc;
          },
          []
        );
        const newBilboards = Object.entries(byScreenId).reduce(
          (acc, [screenId, screenData]) => {
            acc.push({
              ...screenData,
              name: screenId,
              percent: +(
                ((screenData.impressions ?? 0) / screenImpressions) *
                100
              ).toFixed(2),
            });
            return acc;
          },
          []
        );
        const newAdGroupId = Object.entries(byAdGroupId).reduce(
          (acc, [adGroupId, adGroupIdData]) => {
            acc.push({
              ...adGroupIdData,
              name: adGroupId,
            });
            return acc;
          },
          []
        );
        const newCreative = Object.entries(byCreative).reduce(
          (acc, [creativeId, creativeData]) => {
            acc.push({
              ...creativeData,
              name: creativeId,
            });
            return acc;
          },
          []
        );
        return {
          ...state,
          heatMapData: {
            loader: fulfilled,
            error: {},
          },
          heatMap: {
            adGroupId: newAdGroupId,
            avgBilboards: newBilboards,
            avgState: newByGeo,
            avgCreative: newCreative,
            state: byGeo,
            billboards: newByScreenId,
          },
        };
      } else {
        return {
          ...state,
          heatMapData: {
            loader: fulfilled,
            data: [],
          },
        };
      }

    case GET_HEAT_MAP_DATA_FAILURE:
      return {
        ...state,
        heatMapData: {
          loader: rejected,
          data: [],
          error: action.error,
        },
      };

    case GET_HEATMAP_FOR_EXPOSURES_REQUEST:
      return {
        ...state,
        dspExposuresData: {
          ...skeleton,
          loader: pending,
        },
      };
    case GET_HEATMAP_FOR_EXPOSURES_SUCCESS:
      const _id = action.payload?.id;
      const newBillboard = _id.biilboard.map((item, index) => {
        const { latitude, longitude, ...rest } = item;
        return {
          ...rest,
          latlng: { latitude, longitude },
        };
      });
      const _state = _id.state.reduce((acc, item) => {
        const { name } = item;
        acc[name] = {
          ...item,
        };
        return acc;
      }, {});
      return {
        ...state,
        dspExposuresData: {
          ...skeleton,
          loader: fulfilled,
          data: action.payload?.id,
        },
        heatMap: {
          adGroupId: _id.adGroupId,
          avgBilboards: newBillboard,
          avgState: _id.state,
          avgCreative: _id.creative,
          state: _state,
          billboards: newBillboard,
        },
      };
    case GET_HEATMAP_FOR_EXPOSURES_FAILURE:
      return {
        ...state,
        dspExposuresData: {
          ...skeleton,
          loader: rejected,
          error: action.error,
        },
      };
    default:
      return state;
  }
}
